export {};

NLMK.initFormParsley = initFormParsley;

$(initFormParsley);

$(document).ajaxComplete(initFormParsley);

function initFormParsley() {
    const $forms = $('form').filter('.js-validate-form');

    if ($forms.length > 0) {
        require.ensure(
            ['./module'],
            () => {
                const { eachOfForm } = require('./module');

                $forms.each(eachOfForm);
            },
            'form-parsley',
        );
    }
}

$(document)
    .on('input change', '.input-text', function onInput() {
        const isEmpty = this.value.length < 1;
        const isFill = !isEmpty;

        $(this)
            .addClass('dirty')
            .toggleClass('empty', isEmpty)
            .toggleClass('fill', isFill);
    })
    .on('keydown', '.js-input-allow-numbers', function(evt) {
        // Allow: backspace, delete, tab, escape, enter and .
        if (
            $.inArray(evt.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
            // Allow: Ctrl/cmd+A
            (evt.keyCode === 65 && (evt.ctrlKey === true || evt.metaKey === true)) ||
            // Allow: Ctrl/cmd+C
            (evt.keyCode === 67 && (evt.ctrlKey === true || evt.metaKey === true)) ||
            // Allow: Ctrl/cmd+X
            (evt.keyCode === 88 && (evt.ctrlKey === true || evt.metaKey === true)) ||
            // Allow: home, end, left, right
            (evt.keyCode >= 35 && evt.keyCode <= 39)
        ) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((evt.shiftKey || (evt.keyCode < 48 || evt.keyCode > 57)) && (evt.keyCode < 96 || evt.keyCode > 105)) {
            evt.preventDefault();
        }
    });



// WEBPACK FOOTER //
// ./js/main/module/form-validation/index.js